import type { Movimentacao } from '../../models';
import { ehItemSimples, mesclarEquipamentosMovimentacao } from '../../models';
import { TIPOS_EQUIPAMENTO_COM_SENHA } from './solicitacaoDetailsPage.definitions';

export interface EtapaMovimentacao {
  id: 'equipamentos' | 'fotos' | 'logistica' | 'termo' | 'assinado' | 'glpi';
  label: string;
  concluida: boolean;
}

/**
 * As 6 etapas de uma Movimentação, na ordem do trabalho do SI — pra barra de progresso do
 * resumo lateral. Mesmas regras de pendenciaMovimentacao (que diz QUAL é o próximo passo);
 * aqui só "feito ou não" de cada bloco.
 */
export function etapasDaMovimentacao(movimentacao: Movimentacao): EtapaMovimentacao[] {
  const itens = mesclarEquipamentosMovimentacao(movimentacao.equipamentosIntake ?? [], movimentacao.equipamentosExecucao ?? []);
  const equipamentosOk =
    itens.length > 0 &&
    itens.every((item) => {
      const periferico = item.tipoEquipamento === 'periferico';
      const temAcessorio = (item.acessorios && item.acessorios.length > 0) || Boolean(item.acessoriosOutros);
      const precisaSenha =
        movimentacao.tipoFluxo === 'envio' &&
        Boolean(item.tipoEquipamento && TIPOS_EQUIPAMENTO_COM_SENHA.includes(item.tipoEquipamento)) &&
        !item.homologado;
      return (
        item.tipoEquipamento != null &&
        (periferico || Boolean(item.patrimonio)) &&
        (periferico || ehItemSimples(item.tipoEquipamento) || Boolean(item.nSerie)) &&
        Boolean(item.condicao) &&
        temAcessorio &&
        (!precisaSenha || Boolean(item.senha))
      );
    });
  const logisticaOk =
    (movimentacao.metodoEntrega !== 'correios' || Boolean(movimentacao.codigoRastreio)) &&
    Boolean(movimentacao.dataEnvio) &&
    Boolean(movimentacao.dataRecebimento);

  return [
    { id: 'equipamentos', label: 'Equipamentos', concluida: equipamentosOk },
    { id: 'fotos', label: 'Fotos', concluida: movimentacao.etapas.fotos === 'concluido' },
    { id: 'logistica', label: 'Logística', concluida: logisticaOk },
    { id: 'termo', label: 'Termo', concluida: movimentacao.etapas.termo === 'concluido' },
    { id: 'assinado', label: 'Assinado', concluida: Boolean(movimentacao.termoAssinado?.url) },
    { id: 'glpi', label: 'GLPI', concluida: itens.length > 0 && itens.every((item) => item.glpiAtualizado) },
  ];
}
